const LOCAL_STORAGE_KEY = "stateToken";

const getStateToken = (): string => {
  return localStorage.getItem(LOCAL_STORAGE_KEY) || "";
};

const saveStateToken = (stateToken: string) => {
  localStorage.setItem(LOCAL_STORAGE_KEY, stateToken);
};

const deleteStateToken = () => {
  localStorage.removeItem(LOCAL_STORAGE_KEY);
};

export { getStateToken, saveStateToken, deleteStateToken };
